// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"EG","blender_bottle_img":"FG","blender_bottle_info":"GG","blender_bottle_title":"HG","blender_bottle_bold":"IG","blender_bottle_usual":"JG","blender_bottle_item_mob":"KG","addbutton":"LG","blender_bottle_title_mob":"MG","blender_bottle_bold_mob":"NG","blender_bottle_usual_mob":"OG","bolder":"PG","bottom_margin_4":"QG","bottom_margin_16":"RG"};
    if(module.hot) {
      // 1715276858918
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  